module.exports = __webpack_public_path__ + "static/media/confeitaria-marina-logo-branding-768x591.caf61e7d.jpg";